import axios, { AxiosResponse } from "axios";
import { ApiErrorHandler } from "../../../../errorHandler";
import { State } from "../../../shared/interfaces/components/activationPage.interface";
import { ErroObj } from "../../../shared/interfaces/model/errorObj.interface";

export const postSetPassword = (payload: State) => {
  // Object created with the keywords that BE/apigee expects.
  const object = {
    password: payload.password,
    token: payload.docId,
  };

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/tenant/user/password`;
  return axios
    .patch(URL, object)
    .then((response: AxiosResponse) => response)
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
};
